import appStage from '~/config/appStage';
import {setDynamicImportEnv} from '@nuskin/account-components';

if (appStage.stage === 'local') {
    const compEnv = process.env.APP_COMP_ENV || 'test';
    setDynamicImportEnv(compEnv);
} else if (appStage.stage !== 'prod') {
    setDynamicImportEnv(appStage.stage || 'test');
} else {
    setDynamicImportEnv({baseUrl: '/static/account-components/'});
}
